<template>
    <Dialog modal v-model:visible="isDialogVisible" @hide="isDialogVisible = false" maximizable
        :style="{ width: '75rem', height: '500px' }" :breakpoints="{ '1199px': '75vw', '575px': '100vw' }">
        <template #header>
            <h2 style="width: 100%; text-align: center;">{{ $t('channel_settings.title') }} </h2>
        </template>
        <TabMenu :model="items" v-model:activeIndex="active" />
        <Card v-if="active === 0">
            <template #title>{{ $t('channel_settings.general_settings') }} #{{ channel.name }} <span class="text-sm">({{ channel.id }})</span></template>
            <template #content>
                <label class="channel_label">{{ $t('channel_settings.topic') }}</label>
                <Editor v-model="channel.topic" editorStyle="height: 120px" class="mt-3 d-none">
                    <template v-slot:toolbar>
                        <span class="ql-formats">
                            <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                            <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                            <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                        </span>
                    </template>
                </Editor>
                <div class="flex flex-column gap-2">
                    <label for="chan_password">{{ $t('channel_settings.password') }}</label>
                    <InputText id="chan_password" v-model="channel.password" aria-describedby="password-help" />
                    <small id="password-help">{{ $t('channel_settings.password_help') }}</small>
                </div>
            </template>
            <template #footer>
                <div class="flex gap-3 mt-1">
                    <Button :label="$t('buttons.close')" severity="secondary" outlined class="w-auto" />
                    <Button :label="$t('buttons.save')" class="w-auto" @click="updateChannel" />
                </div>
            </template>
        </Card>
        <Card v-if="active === 1">
            <template #title>{{ $t('channel_settings.general_settings') }} #{{ channel.name }}</template>
            <template #content>

                <div class="flex flex-column gap-2 settings_field">
                    <div class="settings_field_div">
                        <ToggleSwitch v-model="channel.modes.m" />
                        <label for="chan_password">{{ $t('channel_settings.modes.m.title') }}</label>
                    </div>

                    <small id="password-help">{{ $t('channel_settings.modes.m.help') }}</small>
                </div>

                <div class="flex flex-column gap-2 settings_field">
                    <div class="settings_field_div">
                        <ToggleSwitch v-model="channel.modes.M" />
                        <label for="chan_password">{{ $t('channel_settings.modes.M.title') }}</label>
                    </div>

                    <small id="password-help">{{ $t('channel_settings.modes.M.help') }}</small>
                </div>

                <div class="flex flex-column gap-2 settings_field">
                    <div class="settings_field_div">
                        <ToggleSwitch v-model="channel.modes.u" />
                        <label for="chan_password">{{ $t('channel_settings.modes.u.title') }}</label>
                    </div>

                    <small id="password-help">{{ $t('channel_settings.modes.u.help') }}</small>
                </div>

                <div class="flex flex-column gap-2 settings_field">
                    <div class="settings_field_div">
                        <ToggleSwitch v-model="channel.modes.U" />
                        <label for="chan_password">{{ $t('channel_settings.modes.U.title') }}</label>
                    </div>

                    <small id="password-help">{{ $t('channel_settings.modes.U.help') }}</small>
                </div>

            </template>
            <template #footer>
                <div class="flex gap-3 mt-1">
                    <Button :label="$t('buttons.close')" severity="secondary" outlined class="w-auto" />
                    <Button :label="$t('buttons.save')" class="w-auto" @click="saveModes" />
                </div>
            </template>
        </Card>
        <Card v-if="active === 2">
            <template #title>{{ $t('channel_settings.ban_list') }}</template>
            <template #content>
                <DataTable :value="channel.bans" size="small" tableStyle="min-width: 50rem">
                    <Column field="target_id" header="UserID"></Column>
                    <Column field="target_ip" header="Ip Address"></Column>
                    <Column field="target_nickname" header="Nickname"></Column>
                    <Column field="reason" header="reason"></Column>
                    <Column field="nickname" header="Moderator"></Column>
                    <Column field="" header="Action">
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-danger"
                                @click="deleteBan(slotProps.data)"></Button>
                        </template>
                    </Column>
                </DataTable>
            </template>
        </Card>
        <Card v-if="active === 3">
            <template #title>
                <div class="flex justify-content-between align-items-center w-full">{{
                    $t('channel_settings.access_list') }}
                    <Button :label="$t('buttons.add')" icon="pi pi-plus" class="p-button-success ml-auto"
                        @click="openAccessDialog()"></Button>
                </div>
            </template>
            <template #content>
                <DataTable :value="accessDetails" size="small" tableStyle="min-width: 50rem">
                    <Column field="nickname" header="Nickname"></Column>
                    <Column field="access" header="Access"></Column>
                    <Column field="levelTitle" header="Level"></Column>
                    <Column header="Action">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" @click="manageAccess(slotProps.data)" size="small"></Button>
                            <Button icon="pi pi-trash" class="p-button-danger ml-1" size="small"
                                @click="deleteAccess(slotProps.data)"></Button>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-card-title mt-3">
                    <div class="flex justify-content-between align-items-center w-full">
                        {{ $t('channel_settings.level_list') }}
                        <Button :label="$t('buttons.add')" icon="pi pi-plus" class="p-button-success ml-auto"
                            @click="openLevelDialog()"></Button>
                    </div>
                </div>
                <DataTable :value="channel.levels" size="small" tableStyle="min-width: 50rem">
                    <Column field="access" header="Access"></Column>
                    <Column field="title" header="Title"></Column>
                    <Column field="color" header="Color"></Column>
                    <Column header="Action">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" @click="editLevel(slotProps.data)" size="small"></Button>
                            <Button icon="pi pi-trash" class="p-button-danger ml-1" size="small"
                                @click="deleteLevel(slotProps.data)"></Button>
                        </template>
                    </Column>
                </DataTable>
            </template>
        </Card>
    </Dialog>


    <!-- Access Dialog -->
    <Dialog modal v-model:visible="isAccessDialogVisible" @hide="isAccessDialogVisible = false" header="Manage Access">
        <div class="p-fluid">
            <div class="p-field">
                <label for="nickname">Nick</label>
                <AutoComplete id="nickname" v-model="selectedUser" :suggestions="filteredUsers"
                    @complete="searchUsers" />
            </div>
            <div class="p-field">
                <label for="level">Level</label>
                <Dropdown id="level" v-model="selectedLevel" :options="channel.levels" optionLabel="title"
                    optionValue="access" />
            </div>
        </div>
        <template #footer>
            <Button :label="$t('buttons.cancel')" @click="isAccessDialogVisible = false" class="p-button-text" />
            <Button :label="$t('buttons.save')" @click="saveAccess" class="p-button-primary" />
        </template>
    </Dialog>

    <!-- Level Dialog -->
    <Dialog modal v-model:visible="isLevelDialogVisible" @hide="isLevelDialogVisible = false" header="Manage Level">
        <div class="p-fluid">
            <div class="p-field">
                <label for="levelName">Level</label>
                <InputText id="levelName" v-model="levelForm.title" />
            </div>
            <div class="p-field">
                <label for="access">Access</label>
                <InputNumber id="access" v-model="levelForm.access" :min="1" :max="999" />
            </div>
            <div class="p-field">
                <label for="color">{{ $t('buttons.color') }}</label>
                <InputText id="color" v-model="levelForm.color" :type="'color'" />
            </div>
        </div>
        <template #footer>
            <Button :label="$t('buttons.cancel')" @click="isLevelDialogVisible = false" class="p-button-text" />
            <Button :label="$t('buttons.save')" @click="saveLevel" class="p-button-primary" />
        </template>
    </Dialog>

</template>

<script>
/*
import AvatarUpload from './AvatarUpload.vue';

*/


export default {
    components: {
        /*
          AvatarUpload,
          ProfileForm,
          PasswordChangeForm,
          Theme
        */
    },
    data() {
        return {
            isDialogVisible: false,
            isAccessDialogVisible: false,
            isLevelDialogVisible: false,
            channel: {
                topic: '',
                id: 0,
                bans: []
            },
            active: 0,
            items: [
                { label: 'Settings', icon: 'pi pi-home' },
                { label: 'Modes', icon: 'pi pi-lock' },
                { label: 'Ban List', icon: 'pi pi-chart-line' },
                { label: 'Access List', icon: 'pi pi-list' },
            ],
            users: [], // Placeholder for users data
            filteredUsers: [],
            selectedUser: null,
            selectedLevel: null,
            levelForm: {
                title: '',
                access: null,
                color: ''
            }
        };
    },
    computed: {
        accessDetails() {
            return this.channel.access_list.map(accessItem => {
                const matchingLevel = this.channel.levels.find(level => level.access === accessItem.access);
                const levelTitle = matchingLevel ? matchingLevel.title : 'No matching level';
                return {
                    ...accessItem,
                    levelTitle
                };
            });
        }
    },
    methods: {
        updateChannel() {
            this.$socket.emit('saveChannelSetting', { id: this.channel.id, topic: this.channel.topic, smile: this.channel.smile, password: this.channel.password });
        },
        saveModes() {
            this.$socket.emit('modes', { channel_id: this.channel.id, modes: this.channel.modes });
        },
        openDialog() {
            this.active = 0;
            this.isDialogVisible = true;
        },
        openAccessDialog() {
            this.isAccessDialogVisible = true;
        },
        openLevelDialog() {
            this.isLevelDialogVisible = true;
        },
        deleteBan(data) {
            this.$socket.emit('removeBan', data);
            console.log(data);
        },
        manageAccess(data) {
            this.selectedUser = data.nickname;
            this.selectedLevel = data.access;
            this.openAccessDialog();
        },
        deleteAccess(data) {
            this.$socket.emit('removeAccess', data);
            console.log(data);
        },
        saveAccess() {
            var access_data = { id: this.channel.id, nickname: this.selectedUser, access: this.selectedLevel };
            this.$socket.emit('addAccess', access_data);
            this.isAccessDialogVisible = false;
        },
        editLevel(data) {
            this.levelForm = { ...data };
            this.openLevelDialog();
        },
        deleteLevel(data) {
            this.$socket.emit('removeLevel', data);
            console.log(data);
        },
        saveLevel() {
            // Save level logic here
            var level_data = { ...this.levelForm };
            level_data.channel_id = this.channel.id;
            this.$socket.emit('addLevel', level_data);
            this.isLevelDialogVisible = false;
        },
        searchUsers(event) {
            const query = event.query ? event.query.toLowerCase() : '';
            this.filteredUsers = this.channel.users
                .filter(user => user.nickname && user.nickname.toLowerCase().includes(query))
                .map(user => user.nickname);
        },


    },
    watch: {
        isDialogVisible(newValue) {
            if (newValue == true) {
                this.$socket.on('banRemoved', (data) => {
                    this.channel.bans = this.channel.bans.filter(ban => ban.id !== data.id);
                });
            } else {
                this.$socket.off('banRemoved');
            }
        }

    },
    unmounted() {
        this.$socket.off('banRemoved');
    }
}
</script>
<style scoped>
.settings_field_div {
    display: flex;
    align-items: center;
    gap: 10px;
}
.settings_field {
    margin-bottom: 10px;
}
.text-sm {
    font-size: 0.875rem;
}
</style>